<template>
    <div class="grid grid-box card" @click="$router.push('/case-studies/' + project.slug)">
        <div >
            <img :src="project.photos[0]" alt>
        </div>
        <div class="details">
            <span class="text">{{project.client}}</span>
            <h4><a href="#">{{project.job}}</a></h4>
        </div>
    </div>
</template>

<script>
export default {
    name: 'project',
    props: ['project']
}
</script>

<style scoped>
 .grid-box {
    position: relative;
}
.grid-box:hover {
    cursor: pointer;
}
.details {
    width: 100%;
    padding: 0 35px;
    position: absolute;
    left: 0;
    bottom: 50px;
    z-index: 2;
}
.text {
    font-family: "Barlow Condensed", sans-serif;
    font-size: 18px;
    font-size: 1.2rem;
    color: #f6c606 !important;
    text-transform: uppercase;
}
.grid-box::after {
    background: -webkit-linear-gradient(top, #f6c606 20%, #1e1f2c)!important;
    opacity: 0;
    /* -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -ms-transition: all 0.3 */
    transition: all 0.3s;
}
</style>
